<template>
  <div class="vx-row">
    <div
      v-for="product in monthTable.products"
      :key="product.product_type"
      class="vx-col ml-auto mr-auto w-full mt-base"
    >
      <vx-card :title="$t(`Producttypes.${product.product_type}`)">
        <table class="mb-base w-full">
          <tr>
            <th></th>
            <th>Per</th>
            <th style="text-align: right;">Prijs</th>
          </tr>
          <tr v-for="price in product.prices" :key="price.name">
            <th>{{ price.name }}</th>
            <td>
              {{ $t(`PriceUnit.${price.unit}`) }}
            </td>
            <th style="text-align: right;">
              <money-format
                v-if="price.price_incl_vat"
                :value="price.price_incl_vat"
                locale="nl"
                currency-code="EUR"
                :subunit-value="true"
                :hide-subunits="false"
                :supplementalPrecision="3"
              />
            </th>
          </tr>
        </table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  props: ["monthTable"],
  components: { MoneyFormat },
};
</script>

<style></style>
